module.exports = __webpack_public_path__ + "img/menu1-1_bk.666a5d0d.jpg";